export default __webpack_public_path__ + "static/media/M25.9fab45c3.svg";